import { render, staticRenderFns } from "./AssistenteProjeto.vue?vue&type=template&id=04ab89de&scoped=true"
import script from "./AssistenteProjeto.vue?vue&type=script&lang=js"
export * from "./AssistenteProjeto.vue?vue&type=script&lang=js"
import style0 from "./AssistenteProjeto.vue?vue&type=style&index=0&id=04ab89de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ab89de",
  null
  
)

export default component.exports